export default "__VITE_PUBLIC_ASSET__b145d9f2__"